import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Page} from '@/app/core/models/page';
import {environment} from '@/environments/environment';
import {Gallery, GalleryTiny} from '@/app/core/models/gallery';

@Injectable({
	providedIn: 'root'
})
export class GalleryService {

	constructor(
		private readonly http: HttpClient
	) {}

	getPaginatedGalleries(page: number): Observable<Page<GalleryTiny>> {
		return this.http.get<Page<GalleryTiny>>(`${environment.backendUrl}/gallery?page=${page}`);
	}

	getClubGalleries(): Observable<GalleryTiny[]> {
		return this.http.get<GalleryTiny[]>(`${environment.backendUrl}/gallery/club`);
	}

	getGallery(galleryId: string): Observable<Gallery> {
		return this.http.get<Gallery>(`${environment.backendUrl}/gallery/${galleryId}`);
	}
}
